<template>
  <vue-tel-input
    :id="inputFieldId"
    type="text"
    :value="value"
    :required="data.required"
    mode="international"
    :disabled="data.disabled"
    :name="name"
    :auto-format="true"
    :placeholder="data.placeholder"
    :valid-characters-only="true"
    :custom-validate="/^[0-9]*$/"
    :inputClasses="data.inputClass + 'default-font-color'"
    v-on:country-changed="countryChanged"
    @input="input"
    defaultCountry="id"
  />
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { InputMixin } from "./mixin/InputMixin.js";

export default {
  name: "TelInput",
  mixins: [InputMixin],
  components: { VueTelInput },
  data() {
    return {
      dialCode: "",
    }
  },
  methods: {
    input(value, phone) {
      this.$emit("input", value);
      this.$emit("dial-code", this.dialCode);
    },
    countryChanged(country) {
      this.dialCode = country.dialCode;
    },
  },
};
</script>
